import { Grid, TextField, FormControl } from "@mui/material";
import { useFormikContext } from "formik";
import moment from "moment-timezone";
import React, { memo } from "react";
import UpdateSection from "../../../../../common/updateSection/UpdateSection";
import commonLocales from "../../../../../common/config/commonLocale.json";
import states from "../../../../../common/config/states.json";
import { isNil } from "ramda";
import TextInput from "../../../../../common/formElements/TextInput";
import AutocompleteField from "../../../../../common/formElements/AutocompleteField";

interface EditLocationProps {
  bulk: boolean;
  testOnly: boolean;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}
const listTimeZone = moment.tz.names();

function EditLocationComponent({ bulk, isUpdateAllowed, shouldHideField }: EditLocationProps) {
  const formikProps = useFormikContext();
  const { setFieldValue } = formikProps;

  return (
    <Grid container spacing={2}>
      {bulk && (
        <Grid item xs={12}>
          <UpdateSection name="sections.location" />
        </Grid>
      )}

      <Grid item xs={12}>
        <TextInput
          fieldname="attributes.Location"
          label="Location"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          fieldname="attributes.Address1"
          label="Address 1"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          fieldname="attributes.Address2"
          label="Address 2"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AutocompleteField
          fieldname="attributes.TZ"
          id="tz-autocomplete"
          options={listTimeZone}
          onChange={(_event, value: string) => {
            !isNil(value) && setFieldValue("attributes.TZ", value);
          }}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="TZ" />
          )}
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <AutocompleteField
            fieldname="attributes.Locale"
            id="locale-autocomplete"
            options={commonLocales}
            onChange={(_event, value: string) => {
              !isNil(value) && setFieldValue("attributes.Locale", value);
            }}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="Locale" />
            )}
            disabled={!isUpdateAllowed}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <AutocompleteField
          fieldname="attributes.AddressState"
          id="address-state-autocomplete"
          options={states}
          onChange={(_event, value: string) => {
            !isNil(value) && setFieldValue("attributes.AddressState", value);
          }}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="State" />
          )}
          disabled={!isUpdateAllowed}
        />
      </Grid>
    </Grid>
  );
}
export default memo(EditLocationComponent);
